<template>
  <div class="my-container" :class="{'border':border}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" scoped>
.my-container
  display flex
  flex-flow wrap row
  background: #fff;
  // margin-bottom 16px
  // margin-top 16px
  &.border
    box-shadow: 0px 0px 4px rgba(204, 204, 204, 1)
</style>



// WEBPACK FOOTER //
// src/components/base/panel/PanelContainer.vue